module.exports = __webpack_public_path__ + "img/2.281c228f.png";